import React from 'react';
import { Stack, Text } from '@moda/om';
import { OrderItemReturnPolicy } from '../../../constants';
import { LineItemReturnPolicyHeader } from '../../ReturnPolicyInformation';

interface Props {
  returnPolicy: string | undefined;
  returnPolicyCode: OrderItemReturnPolicy;
}
export const LineItemReturnPolicy: React.FC<Props> = ({ returnPolicy, returnPolicyCode }) => {
  if (!returnPolicy) return null;

  return (
    <Stack space={2}>
      <LineItemReturnPolicyHeader returnPolicyCode={returnPolicyCode} />

      <Text>{returnPolicy}</Text>
    </Stack>
  );
};
